import type { SearchAchNotificationOfChangeItemDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export class AchNoticeOfChange extends DomainEntity<SearchAchNotificationOfChangeItemDto> {
    public createDefault(): this {
        return new AchNoticeOfChange({}) as this;
    }

    public get uniqueId() {
        return this.dto.achNocTransactionUniqueId ?? '';
    }

    public get effectiveDate() {
        return this.dto.effectiveDate ?? '';
    }

    public get receivedDate() {
        return this.dto.receivedDate ?? '';
    }

    public get achCompanyName() {
        return this.dto.achCompanyName ?? '';
    }

    public get companyEntryDescription() {
        return this.dto.companyEntryDescription ?? '';
    }

    public get changeCode() {
        return this.dto.changeCode ?? '';
    }

    public get fullReturnReason() {
        return this.changeCode;
    }

    public get originalSecCode() {
        return this.dto.secCode?.original ?? '';
    }

    public get updatedSecCode() {
        return this.dto.secCode?.updated ?? '';
    }

    public get originalRecipientName() {
        return this.dto.recipientName?.original ?? '';
    }

    public get updatedRecipientName() {
        return this.dto.recipientName?.updated ?? '';
    }

    public get originalRecipientFi() {
        return this.dto.recipientFinancialInstitution?.original ?? '';
    }

    public get updatedRecipientFi() {
        return this.dto.recipientFinancialInstitution?.updated ?? '';
    }

    public get originalAccountNumber() {
        return this.dto.accountNumber?.original ?? '';
    }

    public get updatedAccountNumber() {
        return this.dto.accountNumber?.updated ?? '';
    }

    public get originalAccountType() {
        return this.dto.accountType?.original ?? '';
    }

    public get updatedAccountType() {
        return this.dto.accountType?.updated ?? '';
    }

    public get originalIdNumber() {
        return this.dto.identificationNumber?.original ?? '';
    }

    public get updatedIdNumber() {
        return this.dto.identificationNumber?.updated ?? '';
    }

    public get originalTraceNumber() {
        return this.dto.traceNumber?.original ?? '';
    }

    public get updatedTraceNumber() {
        return this.dto.traceNumber?.updated ?? '';
    }
}
